import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-loading',
  template: `
    <div class="flex min-h-screen items-center justify-center bg-white">
      <img src="assets/images/loading.svg" alt="HomeBuyer Logo" class="h-auto w-1/2 md:w-96" />
      <router-outlet></router-outlet>
    </div>
  `,
  styles: [],
  imports: [RouterOutlet],
})
export class LoadingComponent {}
